<template>
  <BootstrapModal class="EditWebsiteMenu"
                  v-on="$listeners"

                  @save="saveProductGroup"
  >
    <template>
      <div>
        <div v-if="blockDate" class="TAILWIND">
          <div class="border-l-4 border-yellow-400 bg-yellow-50 p-2 px-3 mb-2">
            <div class="flex">
              <div class="flex-shrink-0">
                <svg class="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
                </svg>
              </div>
              <div class="ml-1.5">
                <p class="text-sm text-yellow-700 m-0">
                  Blocked until {{ blockFormattedDate }}. {{ parseInt(blockDate.hours + '', 10) }} hours and {{ blockDate.minutes.toFixed(0) }} minutes left.
                </p>
              </div>
            </div>
          </div>
        </div>

        <FormInput
          class="form-element"
          v-model="$v.hours.$model"

          id="hours"
          label="Uur"

          :vuelidate="$v"
          fieldName="hours"
        />
      </div>
    </template>

    <template v-if="blockDate" #left-btn>
      <button class="btn btn-danger" @click="disableSyncBlock">
        Disable block
      </button>
    </template>

    <template #title>
      Zet PostNL synchronisatie tijdelijk uit
    </template>
  </BootstrapModal>
</template>

<script>

import BootstrapModal from "../BootstrapModal.vue"
import FormInput from "src/components/Inputs/FormInput.vue"

import { required, numeric } from "vuelidate/lib/validators"
import postNlBlockSync from "@/mixins/postnl-block-sync"

export default {
  mixins: [postNlBlockSync],
  props: ['callback'],
  components: {
    BootstrapModal,
    FormInput,
  },
  validations: {
    hours: {
      required,
      numeric,
    },
  },
  data() {
    return {
      hours: "",
    }
  },
  methods: {
    async saveProductGroup() {
      this.$v.$touch()
      if (this.$v.$error) return;

      await this.$handlePromise(async () => {
        await this.axios.post(`/api/orders/temporarily-stop-sync`, { hours: this.$v.hours.$model })
        this.callback && this.callback()
      })
      await this.loadCurrentBlock()
    },
    async disableSyncBlock() {
      await this.$handlePromise(async () => {
        await this.axios.post(`/api/orders/disable-sync-block`)
        this.callback && this.callback()
        this.$emit("close")
      })
    },
  },
}

</script>

<style scoped>

.EditWebsiteMenu {
  flex-basis: 600px;
}

</style>
